import { m } from '@pricedrop/i18n';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export function HomeBottomCta() {
  return (
    <section className="container mx-auto px-4">
      <div className="rounded-2xl bg-gradient-to-br from-blue-600/5 via-purple-600/5 to-blue-600/5 p-10 text-center sm:p-14 dark:from-blue-950/20 dark:via-purple-950/20 dark:to-blue-950/20">
        <h2 className="mb-3 text-2xl font-bold tracking-tight sm:text-3xl">{m.home_cta_title()}</h2>
        <p className="mb-8 text-muted-foreground">{m.home_cta_subtitle()}</p>
        <Button
          asChild
          size="lg"
          className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 border-0 text-white font-medium transition-all duration-300 hover:shadow-md hover:shadow-blue-500/20 hover:-translate-y-0.5"
        >
          <Link to="/login">{m.home_cta_button()}</Link>
        </Button>
      </div>
    </section>
  );
}
